import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './index.css';

interface Destaque {
    cdAnuncio: number;
    vlAnuncio: any;
    nmAnuncio: string;
    imagem: string;
}

const CarouselAnunciosDestaques = ({ destaques }: { destaques: Destaque[] }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const isMobile = windowWidth <= 700;

    // Remove duplicatas pelo cdAnuncio
    const uniqueDestaques = destaques.filter((destaque, index, self) =>
        index === self.findIndex(d => d.cdAnuncio === destaque.cdAnuncio)
    );

    const showArrowsOrAutoPlay = uniqueDestaques.length >= 4;

    return (
        <div className='carouselDestaque'>
            <Carousel
                showArrows={isMobile ? true : showArrowsOrAutoPlay}
                showStatus={false}
                emulateTouch={true}
                showIndicators={false}
                autoPlay={isMobile ? true : showArrowsOrAutoPlay}
                interval={5000}
                transitionTime={200}
                stopOnHover={true}
                swipeable={true}
                centerMode={true}
                centerSlidePercentage={isMobile ? 100 : 25}
                infiniteLoop={false}  
                className="custom-carousel"
            >
                {uniqueDestaques.map((destaque) => (
                    <Link key={destaque.cdAnuncio} to={`/milshop/anuncio/ver-detalhes/${destaque.cdAnuncio}`} className='linkNavegacaoCardAnuncio'>
                        <div className='slideContent'>
                            <img src={destaque.imagem} alt={destaque.nmAnuncio} />
                            <div className='informacoesCardDestaques'>
                                <p className='textoCarousel'>{destaque.nmAnuncio}</p>
                                <p className='textoCarousel texto-preco'>{`R$ ${destaque.vlAnuncio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</p>
                            </div>
                        </div>
                    </Link>
                ))}
            </Carousel>
        </div>
    );
};

export default CarouselAnunciosDestaques;
